import { FIELDS } from '@/pages/Inventory/constants';

export const addSourceInventoryFields = [  
  {
    key: 'PartNumber',
    field: FIELDS.PART_NUMBER,
    title: ' Part Number',
    label: 'PartNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SourceName',
    field: FIELDS.SOURCE_NAME,
    title: ' Source Name',
    label: 'SourceName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CompanyName',
    field: FIELDS.COMPANY_NAME,
    title: ' Company Name',
    label: 'CompanyName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  
  {
    key: 'VendorTypeName',
    field: FIELDS.VENDOR_TYPE_NAME,
    title: ' Vendor Type',
    label: 'VendorTypeName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ContactFullName',
    field: FIELDS.CONTACT_FULL_NAME,
    title: ' Contact Full Name',
    label: 'ContactFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PurchaseOrderId',
    field: FIELDS.PURCHASE_ORDER_ID,
    title: ' Purchase Order Id',
    label: 'PurchaseOrderId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PODate',
    field: FIELDS.PODATE,
    title: ' PODate',
    label: 'PODate',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConsignmentId',
    field: FIELDS.CONSIGNMENT_ID,
    title: ' Consignment Id',
    label: 'ConsignmentId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CustomerId',
    field: FIELDS.CUSTOMER_ID,
    title: ' Customer Id',
    label: 'CustomerId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CustomerName',
    field: FIELDS.CUSTOMER_NAME,
    title: ' Customer Name',
    label: 'CustomerName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SalesPersonUserFullName',
    field: FIELDS.SALES_PERSON_USER_FULL_NAME,
    title: ' Sales Person User Full Name',
    label: 'SalesPersonUserFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShippingProviderName',
    field: FIELDS.SHIPPING_PROVIDER_NAME,
    title: ' Shipping Provider Name',
    label: 'ShippingProviderName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShippingMethodId',
    field: FIELDS.SHIPPING_METHOD_ID,
    title: ' Shipping Method Id',
    label: 'ShippingMethodId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ShippingMethodName',
    field: FIELDS.SHIPPING_METHOD_NAME,
    title: ' Shipping Method Name',
    label: 'ShippingMethodName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TrackingNumber',
    field: FIELDS.TRACKING_NUMBER,
    title: ' Tracking Number',
    label: 'TrackingNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SalesOrderLineId',
    field: FIELDS.SALES_ORDER_LINE_ID,
    title: ' Sales Order Line Id',
    label: 'SalesOrderLineId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PurchaseOrderLineId',
    field: FIELDS.PURCHASE_ORDER_LINE_ID,
    title: ' Purchase Order Line Id',
    label: 'PurchaseOrderLineId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'POConditionId',
    field: FIELDS.POCONDITION_ID,
    title: ' POCondition Id',
    label: 'POConditionId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'POConditionName',
    field: FIELDS.POCONDITION_NAME,
    title: ' POCondition Name',
    label: 'POConditionName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'QuantitySold',
    field: FIELDS.QUANTITY_SOLD,
    title: ' Quantity Sold',
    label: 'QuantitySold',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PartId',
    field: FIELDS.PART_ID,
    title: ' Part Id',
    label: 'PartId',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'VendorPartNumber',
    field: FIELDS.VENDOR_PART_NUMBER,
    title: ' Vendor Part Number',
    label: 'VendorPartNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InternalPN',
    field: FIELDS.INTERNAL_PN,
    title: ' Internal PN',
    label: 'InternalPN',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'NSNNumber',
    field: FIELDS.NSNNUMBER,
    title: ' NSNNumber',
    label: 'NSNNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AltNumber',
    field: FIELDS.ALT_NUMBER,
    title: ' Alt Number',
    label: 'AltNumber',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'SKU',
    field: FIELDS.SKU,
    title: ' SKU',
    label: 'SKU',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'HarmonizedCode',
    field: FIELDS.HARMONIZED_CODE,
    title: ' Harmonized Code',
    label: 'HarmonizedCode',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Description',
    field: FIELDS.DESCRIPTION,
    title: ' Description',
    label: 'Description',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ManufacturerName',
    field: FIELDS.MANUFACTURER_NAME,
    title: ' Manufacturer Name',
    label: 'ManufacturerName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AltMfr',
    field: FIELDS.ALT_MFR,
    title: ' Alt Mfr',
    label: 'AltMfr',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ClassName',
    field: FIELDS.CLASS_NAME,
    title: ' Class Name',
    label: 'ClassName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CategoryName',
    field: FIELDS.CATEGORY_NAME,
    title: ' Category Name',
    label: 'CategoryName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'UOM',
    field: FIELDS.UOM,
    title: ' UOM',
    label: 'UOM',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Package',
    field: FIELDS.PACKAGE,
    title: ' Package',
    label: 'Package',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PiecePerPkg',
    field: FIELDS.PIECE_PER_PKG,
    title: ' Piece Per Pkg',
    label: 'PiecePerPkg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PhysPkg',
    field: FIELDS.PHYS_PKG,
    title: ' Phys Pkg',
    label: 'PhysPkg',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LeadFree',
    field: FIELDS.LEAD_FREE,
    title: ' Lead Free',
    label: 'LeadFree',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TempRating',
    field: FIELDS.TEMP_RATING,
    title: ' Temp Rating',
    label: 'TempRating',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'PartComments',
    field: FIELDS.PART_COMMENTS,
    title: ' Part Comments',
    label: 'PartComments',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'onHand',
    field: FIELDS.ON_HAND,
    title: 'Local Inventory',
    label: 'On Hand',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Allocated',
    field: FIELDS.ALLOCATED,
    title: ' Allocated',
    label: 'Allocated',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Available',
    field: FIELDS.AVAILABLE,
    title: ' Available',
    label: 'Available',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Returned',
    field: FIELDS.RETURNED,
    title: ' Returned',
    label: 'Returned',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Destroyed',
    field: FIELDS.DESTROYED,
    title: ' Destroyed',
    label: 'Destroyed',
    cell: 'formatSeparator',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'UnitCost',
    field: FIELDS.UNIT_COST,
    title: ' Unit Cost',
    label: 'UnitCost',
    cell: 'formatAmount',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Charges',
    field: FIELDS.CHARGES,
    title: ' Charges',
    label: 'Charges',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Cost',
    field: FIELDS.COST,
    title: ' Cost',
    label: 'Cost',
    cell: 'formatCurrency',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'WarehouseName',
    field: FIELDS.WAREHOUSE_NAME,
    title: ' Warehouse Name',
    label: 'WarehouseName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Location',
    field: FIELDS.LOCATION,
    title: ' Location',
    label: 'Location',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Rack',
    field: FIELDS.RACK,
    title: ' Rack',
    label: 'Rack',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Shelf',
    field: FIELDS.SHELF,
    title: ' Shelf',
    label: 'Shelf',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Bin',
    field: FIELDS.BIN,
    title: ' Bin',
    label: 'Bin',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateCode',
    field: FIELDS.DATE_CODE,
    title: ' Date Code',
    label: 'DateCode',
    cell: 'dynamicNavigation',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'LotCode',
    field: FIELDS.LOT_CODE,
    title: ' Lot Code',
    label: 'LotCode',
    cell: 'dynamicNavigation',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Revision',
    field: FIELDS.REVISION,
    title: ' Revision',
    label: 'Revision',
    cell: 'dynamicNavigation',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConditionName',
    field: FIELDS.CONDITION_NAME,
    title: ' Condition Name',
    label: 'ConditionName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CountryOfOriginName',
    field: FIELDS.COUNTRY_OF_ORIGIN_NAME,
    title: ' Country Of Origin Name',
    label: 'CountryOfOriginName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Comments',
    field: FIELDS.COMMENTS,
    title: ' Comments',
    label: 'Comments',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'IsQuarantined',
    field: FIELDS.IS_QUARANTINED,
    title: ' Is Quarantined',
    label: 'IsQuarantined',
    cell: 'checkMark',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateReceived',
    field: FIELDS.DATE_RECEIVED,
    title: ' Date Received',
    label: 'DateReceived',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'RecievedBy',
    field: FIELDS.RECIEVED_BY,
    title: ' Received By',
    label: 'ReceivedBy',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'RequiresInspection',
    field: FIELDS.REQUIRES_INSPECTION,
    title: ' Requires Inspection',
    label: 'RequiresInspection',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateInspected',
    field: FIELDS.DATE_INSPECTED,
    title: ' Date Inspected',
    label: 'DateInspected',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'InspectedBy',
    field: FIELDS.INSPECTED_BY,
    title: ' Inspected By',
    label: 'InspectedBy',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'RequiresTesting',
    field: FIELDS.REQUIRES_TESTING,
    title: ' Requires Testing',
    label: 'RequiresTesting',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateTested',
    cell: 'formatDate',
    field: FIELDS.DATE_TESTED,
    title: ' Date Tested',
    label: 'DateTested',
    cell: 'formatDate',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'TestedBy',
    field: FIELDS.TESTED_BY,
    title: ' Tested By',
    label: 'TestedBy',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Tested',
    field: FIELDS.TESTED,
    title: ' Tested',
    label: 'Tested',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'AlertMessage',
    field: FIELDS.ALERT_MESSAGE,
    title: ' Alert Message',
    label: 'AlertMessage',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Consigned',
    field: FIELDS.CONSIGNED,
    title: ' Consigned',
    label: 'Consigned',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConsignedToCompanyName',
    field: FIELDS.CONSIGNED_TO_COMPANY_NAME,
    title: ' Consigned To Company Name',
    label: 'ConsignedToCompanyName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ConsignedPercent',
    field: FIELDS.CONSIGNED_PERCENT,
    title: ' Consigned Percent',
    label: 'ConsignedPercent',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'WarrantyName',
    field: FIELDS.WARRANTY_NAME,
    title: ' Warranty Name',
    label: 'WarrantyName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'WarrantyDays',
    field: FIELDS.WARRANTY_DAYS,
    title: ' Warranty Days',
    label: 'WarrantyDays',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateWarrantyExpires',
    cell: 'formatDate',
    field: FIELDS.DATE_WARRANTY_EXPIRES,
    title: ' Date Warranty Expires',
    label: 'DateWarrantyExpires',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'WarrantyNotes',
    field: FIELDS.WARRANTY_NOTES,
    title: ' Warranty Notes',
    label: 'WarrantyNotes',
    sortable: true,
    hidden: false,
    width: 150,
  },
  // {
  //   key: 'IsSplit',
  //   field: FIELDS.IS_SPLIT,
  //   title: ' Is Split',
  //   label: 'IsSplit',
  //   sortable: true,
  //   hidden: false,
  //   width: 150,
  // },
  {
    key: 'DateCreated',
    cell: 'formatDate',
    field: FIELDS.DATE_CREATED,
    title: ' Date Created',
    label: 'DateCreated',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'DateModified',
    cell: 'formatDate',
    field: FIELDS.DATE_MODIFIED,
    title: ' Date Modified',
    label: 'DateModified',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'CreatedByUserId',
    field: FIELDS.CREATED_BY_USER_ID,
    title: ' Created By User Id',
    label: 'CreatedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'CreatedByUserFullName',
    field: FIELDS.CREATED_BY_USER_FULL_NAME,
    title: ' Created By User Full Name',
    label: 'CreatedByUserFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'ModifiedByUserId',
    field: FIELDS.MODIFIED_BY_USER_ID,
    title: ' Modified By User Id',
    label: 'ModifiedByUserId',
    sortable: true,
    hidden: true,
    width: 150,
  },
  {
    key: 'ModifiedyUserFullName',
    field: FIELDS.MODIFIEDY_USER_FULL_NAME,
    title: ' Modifiedy User Full Name',
    label: 'ModifiedyUserFullName',
    sortable: true,
    hidden: false,
    width: 150,
  },
  {
    key: 'Active',
    field: FIELDS.ACTIVE,
    title: ' Active',
    label: 'Active',
    sortable: true,
    hidden: false,
    width: 150,
  },
  
  // {
  //   field: 'detailcommands',
  //   title: '',
  //   cell: 'detailcommands',
  //   headerCell: 'detailCommandsHeader',
  //   sortable: false,
  //   hidden: false,
  //   locked: true,
  //   width: 30,
  // },
  {
    title: ' ',
    headerCell: 'commandsHeader',
    sortable: false,
    hidden: false,
    locked: true,
    width: 30,
  },
];

